import script from "./ProductDetailUpsellItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailUpsellItem.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetailUpsellItem.vue?vue&type=style&index=0&id=fc525bd6&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc525bd6"]])

export default __exports__